import React, { Component } from 'react';

class RichTextErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('RichTextErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className='text-sm text-red-600 p-2 bg-red-50 rounded border border-red-200'>
          <p>⚠️ Content display error</p>
          <p className="text-xs mt-1">Unable to render rich text content</p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default RichTextErrorBoundary;